import * as z from 'zod';

import { userRoleQueryLinkerSchema } from '@/_pages/settings/user-roles/shared';
import { emailSchema } from '@/_schemas/generic';
import { statusFormSchema } from '@/_schemas/status-input';

import { systemUserQuerySchema } from './system-user-query-schema';

export const systemUserFormSchema = systemUserQuerySchema
  .omit({
    first_name: true,
    last_name: true,
    roles: true,
    team_member_id: true,
    api_keys: true,
  })
  .extend({
    first_name: z.string().min(3),
    last_name: z.string(),
    name: z.string(),
    username: z.string(),

    email: emailSchema(),
    status: statusFormSchema,

    user_type: z.string(),
    microsoft_groups: z.string(),
    roles: userRoleQueryLinkerSchema.nullable(),
  });

export type SystemUserFormSchema = z.infer<typeof systemUserFormSchema>;
